import React from "react";
import RedemptionTable from "./RedemptionTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const RedemptionIndex = () => (
  <ReportProgramsPage
    TableComponent={RedemptionTable}
    loadingMessage="Loading redemption report..."
  />
);

export default RedemptionIndex;
